import { render, staticRenderFns } from "./QuestionAnswerView.vue?vue&type=template&id=fb126134&"
import script from "./QuestionAnswerView.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {QuestionAnswerItemOwner: require('/lasso/components/questions/QuestionAnswerItemOwner.vue').default,QuestionAnswerItemParticipant: require('/lasso/components/questions/QuestionAnswerItemParticipant.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb126134')) {
      api.createRecord('fb126134', component.options)
    } else {
      api.reload('fb126134', component.options)
    }
    module.hot.accept("./QuestionAnswerView.vue?vue&type=template&id=fb126134&", function () {
      api.rerender('fb126134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/QuestionAnswerView.vue"
export default component.exports